// PartCPage1.jsx - Part C Page 1 for HPC Report (Pixel-perfect redesign)
import React from 'react';

const PartCPage1 = ({ data }) => {
    const teacherFields = data?.teacher_fields || {};
    const studentFields = data?.student_fields || {};
    const guidingQuestions = studentFields.guiding_questions || [''];

    const RoundedPillBox = ({ labelText, children }) => (
        <div style={{ marginBottom: '8px' }}>
            <div style={{
                backgroundColor: '#F4824C',
                color: 'white',
                padding: '8px 20px',
                borderRadius: '25px',
                fontSize: '11px',
                fontWeight: 'bold',
                marginBottom: '5px',
                display: 'inline-block'
            }}>
                {labelText}
            </div>
            <div style={{
                backgroundColor: '#FFE5D5',
                padding: '10px 15px',
                fontSize: '10px',
                lineHeight: '1.4',
                minHeight: '30px',
                border: '1px solid #F4824C',
                borderRadius: '4px'
            }}>
                {children || '-'}
            </div>
        </div>
    );

    const ChevronBox = ({ labelText, children, bgColor = '#F4824C', contentBg = '#FFE5D5' }) => (
        <div style={{ marginBottom: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'stretch' }}>
                <div style={{
                    backgroundColor: bgColor,
                    color: 'white',
                    padding: '15px 20px',
                    fontSize: '11px',
                    fontWeight: 'bold',
                    clipPath: 'polygon(0 0, 85% 0, 100% 50%, 85% 100%, 0 100%)',
                    minWidth: '200px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    lineHeight: '1.3'
                }}>
                    {labelText}
                </div>
                <div style={{
                    backgroundColor: contentBg,
                    flex: 1,
                    padding: '12px 15px',
                    minHeight: '80px',
                    marginLeft: '-15px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    fontSize: '10px',
                    lineHeight: '1.4'
                }}>
                    {children}
                </div>
            </div>
        </div>
    );

    return (
        <div className="report-page" style={{
            width: '210mm',
            minHeight: '297mm',
            margin: '0 auto',
            padding: '20mm',
            backgroundColor: 'white',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            position: 'relative',
            fontFamily: 'Arial, sans-serif'
        }}>
            <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '0 80px 80px 0',
                borderColor: 'transparent #F4824C transparent transparent'
            }} />

            <div style={{
                backgroundColor: '#F4824C',
                color: 'white',
                padding: '12px 15px',
                fontSize: '18px',
                fontWeight: 'bold',
                textAlign: 'center',
                marginBottom: '20px'
            }}>
                PART C
            </div>

            <div style={{
                backgroundColor: '#F4824C',
                color: 'white',
                padding: '10px 15px',
                fontSize: '13px',
                fontWeight: 'bold',
                marginBottom: '15px'
            }}>
                Problem-Based Inquiry (Individual Work)
            </div>

            <RoundedPillBox labelText="Subject(s)">
                {teacherFields.subjects}
            </RoundedPillBox>

            <RoundedPillBox labelText="Curricular goal(s)">
                {teacherFields.curricular_goals}
            </RoundedPillBox>

            <RoundedPillBox labelText="Competency(-ies)">
                {teacherFields.competencies}
            </RoundedPillBox>

            <div style={{ marginBottom: '10px' }}>
                <div style={{
                    backgroundColor: '#F4824C',
                    color: 'white',
                    padding: '12px 15px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    marginBottom: '5px'
                }}>
                    Pedagogies
                </div>
                <div style={{
                    backgroundColor: '#FFE5D5',
                    padding: '12px 15px',
                    border: '1px solid #F4824C',
                    borderRadius: '4px',
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '8px 20px',
                    fontSize: '10px'
                }}>
                    {[
                        'Arts integrated learning', 'Toy/sport/s-based pedagogy',
                        'Heritage/culture crafts pedagogy', 'Experiential learning',
                        'Story-telling/dramatization', 'Inquiry-driven, discovery/ exploratory learning',
                        'Gamification, puzzles (logic, math)', 'Communication-based activities',
                        'Other (please specify)', ''
                    ].map((item, i) => (
                        <span key={i}>{item || '\u00A0'}</span>
                    ))}
                </div>
            </div>

            <ChevronBox labelText="Research prompt/ question/ problem/ challenge/ planned final output">
                {teacherFields.research_prompt}
            </ChevronBox>

            <ChevronBox labelText="Hypothesis">
                {teacherFields.hypothesis}
            </ChevronBox>

            <div style={{ marginBottom: '15px' }}>
                <div style={{ display: 'flex', alignItems: 'stretch' }}>
                    <div style={{
                        backgroundColor: '#4A90A4',
                        color: 'white',
                        padding: '15px 20px',
                        fontSize: '11px',
                        fontWeight: 'bold',
                        clipPath: 'polygon(0 0, 85% 0, 100% 50%, 85% 100%, 0 100%)',
                        minWidth: '200px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center'
                    }}>
                        <span>Guiding questions</span>
                        <span style={{ fontSize: '18px', marginTop: '3px' }}>↓</span>
                    </div>
                    <div style={{
                        backgroundColor: '#B3D9E8',
                        flex: 1,
                        padding: '15px',
                        marginLeft: '-15px',
                        minHeight: '80px'
                    }}>
                        {guidingQuestions.map((q, i) => (
                            <div key={i} style={{ display: 'flex', gap: '10px', marginBottom: '5px' }}>
                                <span style={{ fontWeight: 'bold', fontSize: '10px', minWidth: '15px' }}>•</span>
                                <span style={{ fontSize: '10px' }}>{q || '-'}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div style={{
                textAlign: 'center',
                fontSize: '11px',
                color: '#666',
                fontWeight: 'bold',
                marginTop: '30px'
            }}>
                19
            </div>

            <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '60px 0 0 60px',
                borderColor: 'transparent transparent transparent #F4824C'
            }} />
            <div style={{
                position: 'absolute',
                bottom: 0,
                right: 0,
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '60px 60px 0 0',
                borderColor: 'transparent #F4824C transparent transparent',
                opacity: 0.3
            }} />
        </div>
    );
};

export default PartCPage1;
